<template>
  <v-select
    class="search-select-item"
    v-model="filters.colorSelected"
    @input="search()"
    item-text="color"
    :items="colors"
    :label="$t('ARTWORK.COLOR')"
    :loading="loading"
    solo
    flat
    hide-details
    clearable
    return-object
    @click:clear="clear()"
    :menu-props="{maxHeight: 'calc(100vh - 24px)'}"
  >
    <template v-slot:selection="{ item, index }">
      <span v-if="index === 0">{{ $t('ARTWORK.COLOR') }}</span>
    </template>
    <template slot="item" slot-scope="data">
      <span
        :class="['color-btn', `color-btn-${data.item.color}`]"
        :style="{backgroundColor: data.item.color}"
      >
        <v-icon
          size="18"
          v-if="isColorSelected(data.item)"
          :color="data.item.name === 'black' ? 'white' : 'black'"
        >fas fa-times</v-icon>
      </span>

      <span class="ml-2">{{ data.item.name }}</span>
    </template>
  </v-select>
</template>

<script>
export default {
  props: ["filters", "colors", "loading"],
  
  watch: {
    "filters.colorSelected": {
      handler: function(val) {
        this.$emit("change");
      }
    }
  },
  methods: {
    clear() {
      this.filters.colorSelected = null;
      this.search();
    },
    search() {
      this.$emit("search");
    },
    isColorSelected(color) {
      return (
        this.filters.colorSelected &&
        this.filters.colorSelected.name === color.name
      );
    }
  }
};
</script>
